/**
 * Draft-theme bridge: Pack Builder cues inside Monster Cart.
 * Only runs when #monster-cart-wrapper exists (Monster embed enabled).
 * Prices/totals follow Shopify cart.js so Monster cart matches checkout.
 */
(function () {
  var STYLE_ID = 'bandify-monster-bridge-style';
  var BOX_ID = 'bandify-monster-pack-box';
  var timer = null;
  var lastSig = '';

  function money(cents) {
    cents = Math.round(Number(cents) || 0);
    var iso = '';
    try {
      if (window.Shopify && Shopify.currency && Shopify.currency.active) {
        iso = String(Shopify.currency.active || '');
      }
    } catch (e0) {}
    if (iso) {
      try {
        return new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: iso,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(cents / 100);
      } catch (e1) {}
    }
    try {
      if (window.Shopify && Shopify.formatMoney) {
        return Shopify.formatMoney(cents, (window.theme && theme.moneyFormat) || undefined);
      }
    } catch (e) {}
    return (iso ? iso + ' ' : '$') + (cents / 100).toFixed(2);
  }

  function ensureStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var css = document.createElement('style');
    css.id = STYLE_ID;
    css.textContent =
      '#' +
      BOX_ID +
      '{margin:10px 12px 12px;padding:12px 14px;border:1px solid #e8e8e8;border-radius:10px;background:#fafafa;font-family:inherit}' +
      '#' +
      BOX_ID +
      ' .bfy-title{font-weight:700;font-size:13px;margin:0 0 8px;color:#162543}' +
      '#' +
      BOX_ID +
      ' .bfy-row{display:flex;justify-content:space-between;gap:8px;font-size:12px;margin:5px 0;color:#162543}' +
      '#' +
      BOX_ID +
      ' .bfy-row.is-save{color:#1a7f4b;font-weight:700}' +
      '#' +
      BOX_ID +
      ' .bfy-row.is-discount{color:#1a7f4b}' +
      '#' +
      BOX_ID +
      ' .bfy-upgrade{margin-top:8px;padding-top:8px;border-top:1px dashed #ddd;font-size:12px;color:#162543}' +
      '#' +
      BOX_ID +
      ' .bfy-note{margin:6px 0 0;font-size:11px;opacity:.85;line-height:1.35}' +
      '#' +
      BOX_ID +
      ' .bfy-total{margin-top:8px;padding-top:8px;border-top:1px solid #e5e5e5;font-weight:700}' +
      '.mu-cart-item.bfy-is-free .mu-item-price{color:#1a7f4b!important}' +
      '.mu-cart-item .bfy-free-pill{display:inline-block;margin:4px 0 0;padding:2px 8px;border-radius:999px;background:#1a7f4b;color:#fff;font-size:10px;font-weight:700;letter-spacing:.02em}' +
      '.mu-cart-item .bfy-pack-pill{display:inline-block;margin:4px 0 0;padding:2px 8px;border-radius:999px;background:#162543;color:#fff;font-size:10px;font-weight:700;letter-spacing:.02em}' +
      '.mu-cart-item.bfy-is-free .bfy-free-price{font-weight:700;color:#1a7f4b}';
    document.head.appendChild(css);
  }

  function monsterRoot() {
    return document.getElementById('monster-cart-wrapper');
  }

  function isMonsterOpen(root) {
    if (!root) return false;
    return /mu_open/.test(root.className) || !/mu_closed/.test(root.className);
  }

  function fetchCart() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) {
      return r.json();
    });
  }

  function isShopifyFree(item) {
    if (!item) return false;
    if (item.final_line_price === 0 && item.original_line_price > 0) return true;
    var disc = item.line_level_total_discount || 0;
    if (item.original_line_price > 0 && disc >= item.original_line_price) return true;
    return false;
  }

  function isPackFreeProp(item) {
    var props = (item && item.properties) || {};
    return String(props._bandify_free) === 'true' || String(props._bandify_slot_type) === 'free';
  }

  function markFreeLines(cart) {
    var byVariant = {};
    (cart.items || []).forEach(function (item) {
      var vid = String(item.variant_id || item.id);
      byVariant[vid] = item;
    });

    document.querySelectorAll('#monster-cart-wrapper .mu-cart-item[data-variant-id]').forEach(function (el) {
      var vid = String(el.getAttribute('data-variant-id') || '');
      var item = byVariant[vid];
      var shopFree = isShopifyFree(item);
      var packProp = isPackFreeProp(item);

      el.classList.toggle('bfy-is-free', shopFree);

      var titleWrap = el.querySelector('.mu-item-title');
      var freePill = el.querySelector('.bfy-free-pill');
      var packPill = el.querySelector('.bfy-pack-pill');

      if (shopFree) {
        if (!freePill && titleWrap) {
          freePill = document.createElement('span');
          freePill.className = 'bfy-free-pill';
          freePill.textContent = 'FREE';
          titleWrap.appendChild(freePill);
        }
        if (packPill) packPill.remove();
      } else {
        if (freePill) freePill.remove();
        if (packProp && titleWrap) {
          if (!packPill) {
            packPill = document.createElement('span');
            packPill.className = 'bfy-pack-pill';
            packPill.textContent = 'PACK FREE SLOT';
            titleWrap.appendChild(packPill);
          }
        } else if (packPill) {
          packPill.remove();
        }
      }

      var priceEl = el.querySelector('.mu-item-price');
      if (priceEl && shopFree) {
        var orig = item.original_line_price || item.original_price || item.price || 0;
        priceEl.innerHTML =
          '<del class="mu-original-price mu-opacity-75 mu-mr-1 notranslate">' +
          money(orig) +
          '</del> <span class="bfy-free-price">FREE</span>';
      }
    });
  }

  function discountRows(cart) {
    var rows = [];
    var seen = {};
    (cart.cart_level_discount_applications || []).forEach(function (d) {
      var title = d.title || d.code || 'Discount';
      var amount = d.total_allocated_amount || 0;
      if (!amount) return;
      seen[title] = true;
      rows.push({ title: title, amount: amount });
    });
    (cart.items || []).forEach(function (item) {
      (item.discounts || []).forEach(function (d) {
        var title = d.title || 'Discount';
        if (seen[title]) return;
        var amount = d.amount || 0;
        if (!amount) return;
        seen[title] = true;
        rows.push({ title: title, amount: amount });
      });
    });
    if (!rows.length && cart.total_discount > 0) {
      rows.push({ title: 'Automatic discount', amount: cart.total_discount });
    }
    return rows;
  }

  function packMeta(cart) {
    var freeCount = 0;
    var paidCount = 0;
    var freeCharged = 0;
    var tier = '';
    (cart.items || []).forEach(function (item) {
      var props = item.properties || {};
      if (!props._bandify_pack_id) return;
      if (String(props._bandify_free) === 'true' || String(props._bandify_slot_type) === 'free') {
        freeCount += item.quantity || 1;
        if (!isShopifyFree(item)) freeCharged += item.final_line_price || 0;
      } else {
        paidCount += item.quantity || 1;
      }
      if (!tier && props._bandify_pack_tier) tier = String(props._bandify_pack_tier);
    });
    return {
      freeCount: freeCount,
      paidCount: paidCount,
      freeCharged: freeCharged,
      tier: tier,
      packItems: freeCount + paidCount
    };
  }

  function renderBox(cart) {
    var root = monsterRoot();
    if (!root) return;

    var anchor =
      root.querySelector('.mu-subtotal') ||
      root.querySelector('.mu-savings') ||
      root.querySelector('.mu-checkout-btn') ||
      root.querySelector('.mu-total');
    if (!anchor || !anchor.parentNode) return;

    var meta = packMeta(cart);
    var rows = discountRows(cart);
    var hasPack = meta.packItems > 0;
    if (!hasPack && !rows.length && !(cart.total_discount > 0)) {
      var old = document.getElementById(BOX_ID);
      if (old) old.remove();
      return;
    }

    var box = document.getElementById(BOX_ID);
    if (!box) {
      box = document.createElement('div');
      box.id = BOX_ID;
    }

    var html = '<p class="bfy-title">Pack offer</p>';
    if (hasPack) {
      html +=
        '<div class="bfy-row"><span>Pack</span><span>' +
        (meta.tier || 'custom') +
        ' · ' +
        meta.paidCount +
        ' paid + ' +
        meta.freeCount +
        ' free slots</span></div>';
    }
    rows.forEach(function (r) {
      html +=
        '<div class="bfy-row is-discount"><span>' +
        r.title +
        '</span><span>-' +
        money(r.amount) +
        '</span></div>';
    });
    if (cart.total_discount > 0) {
      html +=
        '<div class="bfy-row is-save"><span>SAVE</span><span>' + money(cart.total_discount) + '</span></div>';
    }
    html +=
      '<div class="bfy-row bfy-total"><span>Total</span><span>' + money(cart.total_price) + '</span></div>';

    if (meta.freeCount > 0 && meta.freeCharged > 0) {
      html +=
        '<p class="bfy-note">Pack free slots are in the cart. Free Band Offer applies when those products match the discount collections — total above matches checkout.</p>';
    }
    if (meta.tier === '2' || meta.tier === '2+2' || String(meta.tier).indexOf('2') === 0) {
      if (meta.packItems >= 4 && meta.packItems < 6) {
        var upgradeHref = '/collections/best-selling-apple-watch-bands';
        try {
          var packItem = null;
          var items = cart.items || [];
          for (var ui = 0; ui < items.length; ui++) {
            var props = items[ui].properties || {};
            if (props._bandify_pack_id || props._bandify_pack_tier) {
              packItem = items[ui];
              break;
            }
          }
          if (packItem && packItem.url) {
            upgradeHref = String(packItem.url).split('?')[0] + '?bandify_pack=3';
          }
        } catch (eHref) {}
        html +=
          '<div class="bfy-upgrade">' +
          '<div style="margin-bottom:6px"><b>Upgrade:</b> Add 1 more band for 35% off + 1 extra free</div>' +
          '<a href="' +
          upgradeHref +
          '" data-pack-upgrade-open class="bfy-upgrade-link" style="display:inline-flex;align-items:center;justify-content:center;width:100%;padding:10px 12px;border-radius:8px;background:#162543;color:#fff;font-size:12px;font-weight:700;text-decoration:none;text-transform:uppercase;letter-spacing:.04em">Choose 3 Pack bands</a>' +
          '</div>';
      }
    }

    box.innerHTML = html;
    if (box.parentNode !== anchor.parentNode) {
      anchor.parentNode.insertBefore(box, anchor);
    }
  }

  function apply() {
    var root = monsterRoot();
    if (!root) return;
    ensureStyle();
    fetchCart()
      .then(function (cart) {
        var sig =
          String(cart.item_count) +
          ':' +
          String(cart.total_price) +
          ':' +
          String(cart.total_discount) +
          ':' +
          (cart.items || [])
            .map(function (i) {
              return (
                (i.variant_id || i.id) +
                ':' +
                ((i.properties && i.properties._bandify_free) || '') +
                ':' +
                (i.final_line_price || 0)
              );
            })
            .join('|');
        if (sig === lastSig && document.getElementById(BOX_ID)) {
          markFreeLines(cart);
          return;
        }
        lastSig = sig;
        markFreeLines(cart);
        renderBox(cart);
      })
      .catch(function () {});
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(apply, 120);
  }

  function closeMonsterCart() {
    try {
      var monster = monsterRoot();
      if (monster) {
        monster.classList.remove('mu_open');
        monster.classList.add('mu_closed');
        var overlay = document.querySelector('[class*="monster_upsell_overlay"]');
        if (overlay) overlay.style.display = 'none';
      }
    } catch (e) {}
  }

  function openPackUpgradeFromMonster(link) {
    var href = (link && link.getAttribute('href')) || '';
    closeMonsterCart();
    if (typeof window.BandifyOpenPackTier === 'function' && document.querySelector('[data-pack-builder]')) {
      try {
        window.BandifyOpenPackTier('3');
        return;
      } catch (e) {}
    }
    if (href) window.location.href = href;
  }

  function onDocClick(event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var upgradeOpen = target.closest('[data-pack-upgrade-open]');
    if (!upgradeOpen) return;
    // Theme cart drawer is disabled — handle Monster upgrade link here.
    event.preventDefault();
    event.stopPropagation();
    openPackUpgradeFromMonster(upgradeOpen);
  }

  function watch() {
    var root = monsterRoot();
    if (!root) return false;
    ensureStyle();
    schedule();
    try {
      var mo = new MutationObserver(schedule);
      mo.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    } catch (e) {}
    document.addEventListener('cart:change', schedule);
    document.addEventListener('cart:refresh', schedule);
    document.addEventListener('variant:add', schedule);
    document.addEventListener('click', onDocClick, true);
    setInterval(function () {
      if (isMonsterOpen(monsterRoot())) schedule();
    }, 1500);
    return true;
  }

  function boot() {
    if (watch()) return;
    var tries = 0;
    var id = setInterval(function () {
      tries += 1;
      if (watch() || tries > 40) clearInterval(id);
    }, 500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
